module.exports = __webpack_public_path__ + "img/yellow.f5f38d89.png";